import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VueLoadingService } from '@vue/vueframework';
import { defer, finalize, Observable } from 'rxjs';
import { AppDefaultsService } from 'src/app/app-defaults.service';
import { TedBackUpRequest } from '../models/ted-backup-request.model';

@Injectable({
  providedIn: 'root'
})
export class TedBackUpService {
  public constructor(
    private vueAppDefaultsService: AppDefaultsService,
    private http: HttpClient,
    private vueLoadingService: VueLoadingService
  ) {
  }

  public getAuthorization(request: TedBackUpRequest): Observable<string> {
    const url = this.vueAppDefaultsService.getTedUrl() + '/services/TEDHubInternal';
    if (request.authorizationCount === 1) {
      const requestBody = this.buildSingleAuthorizationRequestBody(request);
      return defer(() => {
        this.vueLoadingService.incrementCounter();
        return this.http.post(url, requestBody, {
          headers: new HttpHeaders({ 'Content-Type': 'xml/text' }),
          responseType: 'text'
        }).pipe(
          finalize(() => this.vueLoadingService.decrementCounter())
        );
      });
    }
    const multiAuthRequestBody = this.buildMultiAuthorizationRequestBody(request);
    return defer(() => {
      this.vueLoadingService.incrementCounter();
      return this.http.post(url, multiAuthRequestBody, {
        headers: new HttpHeaders({ 'Content-Type': 'xml/text' }),
        responseType: 'text'
      }).pipe(
        finalize(() => this.vueLoadingService.decrementCounter())
      );
    });
  }

  public buildSingleAuthorizationRequestBody(request: TedBackUpRequest): string {
    const requestBody =
        `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ted="http://ted.hub.vue/">
           <soapenv:Header/>
             <soapenv:Body>
               <ted:getSingleExamAuthorization>
                    <orderItemID>` + request.registrationId + `</orderItemID>
                    <siteID>` + request.siteId + `</siteID>
                    <username>` + request.username + `</username>
                    <challengeKey>` + request.challengeKey + `</challengeKey>
                </ted:getSingleExamAuthorization>
            </soapenv:Body>
           </soapenv:Envelope>`;

    return requestBody;
  }

  public buildMultiAuthorizationRequestBody(request: TedBackUpRequest): string {
    const requestBody =
        `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ted="http://ted.hub.vue/">
           <soapenv:Header/>
             <soapenv:Body>
               <ted:getMultipassExamAuthorization>
                    <orderItemID>` + request.registrationId + `</orderItemID>
                    <siteID>` + request.siteId + `</siteID>
                    <username>` + request.username + `</username>
                    <challengeKey>` + request.challengeKey + `</challengeKey>
                    <authCount>` + request.authorizationCount + `</authCount>
                </ted:getMultipassExamAuthorization>
            </soapenv:Body>
           </soapenv:Envelope>`;

    return requestBody;
  }
}
